(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ambassador-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  $('.ambassador-slider').slick({
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slideToScroll: 1,
    adaptiveHeight: true,
    responsive:[
      {
        breakpoint:749,
    settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
      }
    ]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ambassador"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  $('.custom-ambassador-slider').slick({
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slideToScroll: 1,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
          {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      }
    ]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ambassadors-reviews-custom"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    $('.ambassadeors_info-slider').slick({
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      speed: 600,
      slidesToShow: 3,
      slideToScroll: 1,
      adaptiveHeight: true,
      responsive:[
        {
          breakpoint:990,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint:749,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customs_video_slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  $('.customs_video_slider_section .video-slider').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  document.querySelectorAll('.customs_video_slider_section .play-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const video = this.previousElementSibling;
      if (video.paused) {
        video.play();
        video.setAttribute("controls", true);
        this.style.display = 'none';
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dh-mens-t1-story-sep26"] && !Shopify.designMode) return;
  try {
    
(function(){
  function z(n){return (n<10?'0':'')+n}
  function initTimer(el){
    var start=parseInt(el.dataset.seconds,10)||0, end=el.dataset.end?Date.parse(el.dataset.end):NaN, left=start;
    var H=el.querySelector('[data-h]'),M=el.querySelector('[data-m]'),S=el.querySelector('[data-s]');
    function tick(){
      if(!isNaN(end)){left=Math.max(0,Math.floor((end-Date.now())/1000));}
      else{left=left>0?left-1:start;}
      H.textContent=z(Math.floor(left/3600));M.textContent=z(Math.floor(left%3600/60));S.textContent=z(left%60);
    }
    if(!isNaN(end)) tick();
    setInterval(tick,1000);
  }
  function initProgress(fill){
    function p(){var h=document.documentElement,max=h.scrollHeight-h.clientHeight;fill.style.width=(max>0?Math.min(100,(window.scrollY||h.scrollTop)/max*100):0)+'%';}
    addEventListener('scroll',p,{passive:true});addEventListener('resize',p);p();
  }
  function init(root){
    root.querySelectorAll('[data-zmx26-timer]').forEach(function(el){if(!el.dataset.ready){el.dataset.ready=1;initTimer(el);}});
    root.querySelectorAll('[data-zmx26-fill]').forEach(function(el){if(!el.dataset.ready){el.dataset.ready=1;initProgress(el);}});
  }
  init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-review"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    $('.ambassador-slider').slick({
      dots: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      speed: 600,
      slidesToShow: 3,
      slideToScroll: 1,
      adaptiveHeight: true,
      responsive:[
        {
          breakpoint:749,
      settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["result-testimonial"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.result-testimonial-carousel').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    autoplay:true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          dots:true
        }
      }
    ]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["teaser-block"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var links = document.querySelectorAll('.tl-teaser [data-tl-teaser-anchor]');
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.pushState) {
          history.pushState(null, '', href);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toby_listicle_chapters"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var links = document.querySelectorAll('.tl-chapters [data-tl-chapter-anchor]');
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.pushState) {
          history.pushState(null, '', href);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
